import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_XANO_CERTIFIED_BASE_URL } from "../config/api_config";
import { Api_url } from "../common/api_url";

export const fetchPowerMinuteQuestions = createAsyncThunk(
  "powerminuteQuestions",
  async ({ certified_user_skill_id, successCallback }) => {
    const maxTries = 3;
    let tries = 1;
    while (tries < maxTries) {
      try {
        const response = await axios.get(
          API_XANO_CERTIFIED_BASE_URL + Api_url.PowerMinuteQuiz,
          {
            params: { certified_user_skill_id },
          }
        );
        successCallback?.();
        return response.data?.data;
      } catch (error) {
        console.log(error.message);
        tries += 1;
        if (tries === maxTries) {
          throw error;
        }
      }
    }
  }
);

export const postPowerMinuteResponse = createAsyncThunk(
  "postPowerMinuteResponse",
  async ({
    certified_user_skill_quiz_id,
    powerminute_quiz_attempt_object,
    powerminute_quiz_completion_time_in_secs,
    powerminute_quiz_score,
  }) => {
    try {
      const response = await axios.post(
        API_XANO_CERTIFIED_BASE_URL + Api_url.PostPowerMinuteAnswers,
        {
          certified_user_skill_quiz_id,
          powerminute_quiz_attempt_object,
          powerminute_quiz_completion_time_in_secs,
          powerminute_quiz_score,
        }
      );
      return response.data?.data;
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  }
);

const initialState = {
  powerMinuteQuiz: {},
  fasterThanPercentile: null,
  isPowerMinuteQuizCompleted: false,
  onlyQuizCompleted: false,
  isPowerMinuteSoundMuted: false,
  quizTimer: 60,
  powerminuteQuizStarted: false,
};

const powerminuteSlice = createSlice({
  name: "powerminute",
  initialState,
  reducers: {
    setFasterThanPercentile: (state, action) => {
      state.fasterThanPercentile = action.payload;
    },
    setPowerMinuteQuiz: (state, action) => {
      state.powerMinuteQuiz.questionaire = action.payload;
    },
    setIsPowerMinuteQuizCompleted: (state, action) => {
      state.isPowerMinuteQuizCompleted = action.payload;
    },
    setOnlyQuizCompleted: (state, action) => {
      state.onlyQuizCompleted = action.payload;
    },
    setIsPowerMinuteSoundMuted: (state, action) => {
      state.isPowerMinuteSoundMuted = action.payload;
    },
    setQuizTimer: (state, action) => {
      state.quizTimer = action.payload;
    },
    setPowerminuteQuizStarted: (state, action) => {
      state.powerminuteQuizStarted = action.payload;
    },
    resetPowerminuteDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPowerMinuteQuestions.fulfilled, (state, action) => {
      state.powerMinuteQuiz = action.payload;
    });
    builder.addCase(postPowerMinuteResponse.fulfilled, (state, action) => {
      state.userResponse = action.payload;
    });
  },
});

export const {
  setFasterThanPercentile,
  resetPowerminuteDetails,
  setPowerMinuteQuiz,
  setIsPowerMinuteQuizCompleted,
  setOnlyQuizCompleted,
  setIsPowerMinuteSoundMuted,
  setQuizTimer,
  setPowerminuteQuizStarted,
} = powerminuteSlice.actions;
export const selectFasterThanPercentile = (state) =>
  state.powerminute.fasterThanPercentile;
export const selectPowerMinuteQuiz = (state) =>
  state.powerminute.powerMinuteQuiz?.questionaire;
export const selectIsPowerMinuteQuizCompleted = (state) =>
  state.powerminute.isPowerMinuteQuizCompleted;
export const selectOnlyQuizCompleted = (state) =>
  state.powerminute.onlyQuizCompleted;
export const selectIsPowerMinuteSoundMuted = (state) =>
  state.powerminute.isPowerMinuteSoundMuted;
export const selectQuizTimer = (state) =>
  state.powerminute.quizTimer;
export const selectPowerminuteQuizStarted = (state) =>
  state.powerminute.powerminuteQuizStarted;
export default powerminuteSlice.reducer;
